var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.22 98.33C197.06 44 152.98 0 98.61 0C44.24 0 0 44.15 0 98.61C0 98.52 0 98.42 0 98.33H197.22Z",
    fill: "#DD1F26"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2399 47.3199L51.1699 53.2299L46.0499 49.6099L41.0099 53.3099L42.8599 47.3199L37.8199 43.6599L44.0799 43.5799L46.0499 37.6699L48.0199 43.5799H54.2399L49.2399 47.3199ZM56.1299 67.7999L58.0999 73.7499L52.9799 70.1299L47.8999 73.7899L49.7899 67.8399L44.7499 64.1399L51.0099 64.0999L52.9399 58.1499L54.9099 64.0599H61.2099L56.1299 67.7999ZM79.1699 67.6399L81.0999 73.6299L75.9799 69.9699L70.9399 73.6299L72.7899 67.6799L67.7499 64.0199L74.0099 63.9399L75.9799 58.0299L77.9499 63.9399H84.1699L79.1699 67.6399ZM86.0199 47.3199L87.9499 53.2699L82.8299 49.6499L77.7899 53.3099L79.6799 47.3599L74.5999 43.6599L80.8999 43.6199L82.7899 37.6699L84.7599 43.5799H91.0599L86.0199 47.3199ZM67.7899 33.8099L69.7599 39.7999L64.6399 36.1399L59.5599 39.8399L61.4499 33.8499L56.4099 30.1499L62.6299 30.1099L64.5999 24.1599L66.5699 30.0699H72.8699L67.7899 33.8099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 98.6101C0 153.07 44.15 197.22 98.61 197.22C153.07 197.22 197.22 153.07 197.22 98.6101C197.22 98.5201 197.22 98.4201 197.22 98.3301H0C0 98.4201 0 98.5201 0 98.6101Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.42 52.5101C11.42 55.5301 11.84 58.6001 12.7 61.6501C12.71 61.6901 12.72 61.7301 12.73 61.7701C17.93 79.7401 36.71 90.0901 54.68 84.8901C41.76 82.2401 31.62 72.2101 28.85 59.3101C24.99 41.3601 36.42 23.6901 54.36 19.8301H54.4C49.64 18.5001 45.16 18.1901 40.56 18.8901C28.47 27.7101 18.46 39.2101 11.41 52.5201L11.42 52.5101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197.22,
    height: 197.22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgFlag);
export default __webpack_public_path__ + "static/media/sgFlag.a45d465fdd0319530af6757866e0df34.svg";
export { ForwardRef as ReactComponent };